import AddCircle from '@mui/icons-material/AddCircle';

export const CreateTimeTrackingCircledIcon = AddCircle;
